import React from 'react';
import classNames from 'classnames';
import AntForm from 'antd/lib/form';
import './style';

class Form extends React.Component {
  render() {
    const { className, ...rest } = this.props;
    const computedClassName = classNames('bsa-form', className);
    return (
      <AntForm className={computedClassName} {...rest} />
    );
  }
}

Form.defaultProps = AntForm.defaultProps;
Form.propTypes = AntForm.propTypes;
Form.Item = AntForm.Item;
Form.create = AntForm.create;
Form.createFormField = AntForm.createFormField;
export default Form;
